import { FC } from 'react';

import { StandardItem, StandardItemProps } from './StandardItem';

const FeaturedItem: FC<StandardItemProps> = props => <StandardItem {...props} showImdbRating="always" />;

export { FeaturedItem };
